import { Spinner } from 'react-bootstrap';

export function LoaderSpinner() {
    return (
        <span className="d-inline-flex ml-1">
            <Spinner
                animation="border"
                as="span"
                size="sm"
            ></Spinner>
        </span>
    );
}
